/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';

/**
 *
 * @class KPITableViewerMetadata
 *
 * @brief meta data for opening the KPI Table viewer window
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class KPITableViewerMetadata extends DocumentMetadata {

  /** what KPI Table to focus on */
  public focus:  string = '';

  /** standard constructor */
  constructor(
    id:       string = '',
    title:    string = '',
    focus:    string = '',
    icon:     string = '<i class="far fa-chart-bar"></i>',
    type: WindowType = WindowType.KPITable,
  ) {

    super(id, title, icon, type);

    this.focus  = focus;

  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({focus: this.focus});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.focus  = node.focus;
  }
}
